// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"_2L8V0","image":"oeDPG"};